// extracted by mini-css-extract-plugin
export default {"time":"BusinessHours_time__2V1AN","time_title":"BusinessHours_time_title__lFfLQ","time_content":"BusinessHours_time_content__nUwc9"};